import { findRef } from "./findRef.js";
const findRefByID = (refs, id) => {
  return findRef(refs, ref => ref.id === id);
};
export { findRefByID };